 /*local */ 
// export const apiUrl      = "http://localhost/bloc/api/";
// export const baseUrl      = "http://localhost/bloc";
// export const mediaUrl      = "http://localhost/bloc/media/";
// export const sampleFileUrl      = "http://localhost/bloc/media/sample_file/";
// export const cmscontentURL       = "http://localhost/bloc/media/cmscontent";
// export const categoryURL       = "http://localhost/bloc/media/category";
// export const tapURL       = "http://localhost/bloc/media/tabmanagement";
// export const chatURL       = "http://localhost/bloc/media/smilesy"



/*Dev */

export const apiUrl      = "https://admin.bloc.software/bloc/api/";
export const baseUrl      = "https://admin.bloc.software/bloc";
export const mediaUrl      = "https://admin.bloc.software/bloc/media/";
export const sampleFileUrl      = "https://admin.bloc.software/bloc/media/sample_file/";
export const cmscontentURL       = "https://admin.bloc.software/bloc/media/cmscontent"; 
export const categoryURL       = "http://admin.bloc.software/bloc/media/category";
export const tapURL       = "http://admin.bloc.software/bloc/media/tabmanagement";
export const chatURL       = "http://admin.bloc.software/bloc/media/smilesy";


